import { useCallback, useState } from "react";
import type { HydratedImage } from "../generated/api/types.gen";
import { getErrorMessage } from "../lib/api-client";
import { type DownloadScale, downloadDesignImage } from "../lib/image-download";

/** Download-button state shared by the gallery viewer and the refine top bar.
 *  `index` is the 1-based position within a session, used only for the filename. */
export function useImageDownload(
  image: HydratedImage | null | undefined,
  index?: number,
) {
  const [isDownloading, setIsDownloading] = useState(false);
  const [downloadError, setDownloadError] = useState<string | null>(null);
  const dismissDownloadError = useCallback(() => setDownloadError(null), []);

  const handleDownload = async (scale: DownloadScale) => {
    if (!image) return;
    setIsDownloading(true);
    setDownloadError(null);
    try {
      await downloadDesignImage(image, scale, index);
    } catch (err) {
      console.error("Download failed:", err);
      setDownloadError(getErrorMessage(err));
    } finally {
      setIsDownloading(false);
    }
  };

  return { handleDownload, isDownloading, downloadError, dismissDownloadError };
}
